var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrontLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 226.54,
    height: 49.578,
    viewBox: "0 0 226.54 49.578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_318",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 318",
    transform: "translate(-606.912 -8260.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_40",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 40",
    transform: "translate(606.912 8260.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9",
    "data-name": "\\u30D1\\u30B9 9",
    d: "M134.41,176.576H130.9a10.819,10.819,0,0,1-10.807-10.807V137.8A10.818,10.818,0,0,1,130.9,127h3.515a2.432,2.432,0,0,1,0,4.864H130.9a5.949,5.949,0,0,0-5.943,5.942v27.965a5.95,5.95,0,0,0,5.943,5.943h3.515a2.432,2.432,0,0,1,0,4.864Z",
    transform: "translate(-120.088 -126.998)",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_10",
    "data-name": "\\u30D1\\u30B9 10",
    d: "M150.959,176.576h-3.516a10.818,10.818,0,0,1-10.806-10.807V137.8A10.818,10.818,0,0,1,147.443,127h10.273A10.818,10.818,0,0,1,168.523,137.8v14.87a2.432,2.432,0,1,1-4.864,0V137.8a5.949,5.949,0,0,0-5.943-5.942H147.443A5.948,5.948,0,0,0,141.5,137.8v27.965a5.949,5.949,0,0,0,5.942,5.943h3.516a2.432,2.432,0,1,1,0,4.864Z",
    transform: "translate(-120.088 -126.998)",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11",
    "data-name": "\\u30D1\\u30B9 11",
    d: "M173.015,176.576a9.367,9.367,0,0,1-9.356-9.356V148.4a2.432,2.432,0,0,1,4.864,0V167.22a4.493,4.493,0,0,0,8.985,0V148.4a2.432,2.432,0,0,1,4.864,0V167.22A9.367,9.367,0,0,1,173.015,176.576Z",
    transform: "translate(-120.088 -126.998)",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_12",
    "data-name": "\\u30D1\\u30B9 12",
    d: "M158.66,150.012h-2.027a2.164,2.164,0,0,1,0-4.329h2.027a2.164,2.164,0,0,1,0,4.329Z",
    transform: "translate(-120.088 -126.998)",
    fill: "#0071b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_44",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 44",
    transform: "translate(690.312 8264.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13",
    "data-name": "\\u30D1\\u30B9 13",
    d: "M291.661,169.681l4.409-15.911v-9.142a3,3,0,0,0-3-3h-2.917a1,1,0,0,0-1,1v10.2l-4.928,17.784a1,1,0,0,0,.964,1.267h3.581A3,3,0,0,0,291.661,169.681Z",
    transform: "translate(-203.488 -130.215)",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_41",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 41",
    transform: "translate(35.824 1.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u9577\\u65B9\\u5F62_48",
    "data-name": "\\u9577\\u65B9\\u5F62 48",
    d: "M3,0H26.125a1,1,0,0,1,1,1V4.337a3,3,0,0,1-3,3H1a1,1,0,0,1-1-1V3A3,3,0,0,1,3,0Z",
    transform: "translate(1.782)",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u9577\\u65B9\\u5F62_49",
    "data-name": "\\u9577\\u65B9\\u5F62 49",
    d: "M3,0H29.688a1,1,0,0,1,1,1V4.337a3,3,0,0,1-3,3H1a1,1,0,0,1-1-1V3A3,3,0,0,1,3,0Z",
    transform: "translate(0 12.4)",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_14",
    "data-name": "\\u30D1\\u30B9 14",
    d: "M267.047,170.527h-9.519a10,10,0,0,1-10-10V132.835h6.917v27.692a3.082,3.082,0,0,0,3.082,3.082H264.7a3.515,3.515,0,0,1,3.515,3.515v2.231A1.172,1.172,0,0,1,267.047,170.527Z",
    transform: "translate(-239.312 -131.263)",
    fill: "#0071b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_42",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 42",
    transform: "translate(114.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u9577\\u65B9\\u5F62_50",
    "data-name": "\\u9577\\u65B9\\u5F62 50",
    d: "M3,0H25.592a3,3,0,0,1,3,3V5.337a2,2,0,0,1-2,2H1a1,1,0,0,1-1-1V3A3,3,0,0,1,3,0Z",
    transform: "translate(0 6.101)",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_15",
    "data-name": "\\u30D1\\u30B9 15",
    d: "M326.494,169.681,330.9,153.77V133.215a3,3,0,0,0-3-3h-2.917a1,1,0,0,0-1,1v21.614l-4.928,17.784a1,1,0,0,0,.964,1.267H323.6A3,3,0,0,0,326.494,169.681Z",
    transform: "translate(-318.036 -130.215)",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_16",
    "data-name": "\\u30D1\\u30B9 16",
    d: "M336.957,171.858a1.172,1.172,0,0,1-1.665-1.06l-.009-3.892a2.109,2.109,0,0,1,1.461-2.014l2.034-1.334c.782-.43.932-1.954.932-4.186V141.281h6.918v18.091c0,6.309-2.81,9.936-6.952,11.222Z",
    transform: "translate(-318.036 -130.215)",
    fill: "#0071b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_43",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_17",
    "data-name": "\\u30D1\\u30B9 17",
    d: "M228.168,149.7l-23.2-6.246a1.171,1.171,0,0,0-1.476,1.131v2.964a3.515,3.515,0,0,0,2.6,3.394l23.2,6.236a1.172,1.172,0,0,0,1.476-1.132v-2.953A3.514,3.514,0,0,0,228.168,149.7Z",
    transform: "translate(-203.488 -130.215)",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_18",
    "data-name": "\\u30D1\\u30B9 18",
    d: "M215.759,133.309l-1.736,14.426-9.6,22.514a1.171,1.171,0,0,0,1.077,1.631h3.426a3.515,3.515,0,0,0,3.233-2.136l8.609-20.2,2.169-18.015a1.171,1.171,0,0,0-1.163-1.311h-2.53A3.514,3.514,0,0,0,215.759,133.309Z",
    transform: "translate(-203.488 -130.215)",
    fill: "#0071b9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_19",
    "data-name": "\\u30D1\\u30B9 19",
    d: "M305.552,131.263h0Z",
    transform: "translate(-203.488 -130.215)",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20",
    "data-name": "\\u30D1\\u30B9 20",
    d: "M305.553,131.263H282.188a3.515,3.515,0,0,0-3.514,3.515v2.651a1.171,1.171,0,0,0,1.171,1.171h21.391l-1.4,7.541a1.172,1.172,0,0,0,1.153,1.382h3.793a2.6,2.6,0,0,0,2.507-1.906l1.51-9.092h-.023l.254-1.373A3.5,3.5,0,0,0,305.553,131.263Z",
    transform: "translate(-203.488 -130.215)",
    fill: "#0071b9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontLogo);
export default __webpack_public_path__ + "static/media/front-logo.c855b9237376d469ef66d87f9bb4ff3f.svg";
export { ForwardRef as ReactComponent };